import { Icon } from '@synergy/icons';
import { BasicTable } from '@synergy/table';
import { Col, Flex, Row } from 'antd';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../contexts/AuthContext';
import query from '../../server/constants.api';
import logger from '../../server/server';
import useFetch from '../../server/useFetch';
import { Field, PageContent, PageTitle } from '../../styles/global/Pages.styled';
import Theme from '../../styles/Theme/Theme';
import { REACT_APP_COMMAND_INCIDENT_URL, REACT_APP_COMMAND_LOG_ITEM_URL } from '../../utils/config/configs';
import { base64ToBytes } from '../../utils/hooks/base64ToBytes';
import { formatTimestamp } from '../../utils/hooks/dateSerialization';
import { isLogItem } from '../../utils/hooks/logItems';
import { Button } from '../Global/Atomics/Button';
import Spinner from '../Global/Atomics/Spinner';
import { Text } from '../Global/Atomics/Text';
import { RegisterBuildingSubTabs } from '../Global/Organism/RegisterDetail/RegisterBuildingSubTabs/RegisterBuildingSubTabs';
import { RegisteryGlobalSubTabs } from '../Global/Organism/RegisterDetail/RegisteryGlobalSubTabs/RegisteryGlobalSubTabs';

export const RegisterDetailView = ({ selectedPOI }) => {
    const { t, i18n } = useTranslation();
    const { user, tenant } = useAuthContext();
    const zonesJSON = localStorage.getItem('mico_zones');
    const zones = JSON.parse(zonesJSON);
    const [shortcutButtons] = useState(getTabsHelper(selectedPOI));
    const [filteredBuilding, setFilteredBuilding] = useState(null);
    const [showMore, setShowMore] = useState(false);

    const maxVisibleLines = 5;
    const lineSize = 24;

    //Fetch aos dados
    const {
        data: incidentsBuildingDrawerData,
        refetch: refetchIncidentsBuildingDrawerData,
        remove: removeIncidentsBuildingDrawerData,
        // isLoading: buildingDrawerDataIsLoading
    } = useFetch("/map/services/incidents", "incidentsBuildingDrawerData", {
        id: selectedPOI?.id,
        tenant: selectedPOI?.tenant
    }, false, null, query.middlewareURL);

    useEffect(() => {
        if (selectedPOI && selectedPOI.label !== "Incident" && !isLogItem(selectedPOI)) {
            refetchIncidentsBuildingDrawerData();
        }
    }, [selectedPOI]);

    useEffect(() => {
        return () => {
            removeIncidentsBuildingDrawerData();
        };
    }, []);

    useEffect(() => {
        try {
            if (selectedPOI) {
                var keysToKeep;
                if (selectedPOI.label === "Incident") {
                    keysToKeep = [
                        { label: "description", size: lineSize },
                        { label: 'headlineStatus', size: lineSize },
                        { label: "issueOwnerGroup", size: lineSize },
                        { label: "impactedFA", size: lineSize },
                        { label: "severity", size: lineSize / 2 },
                        { label: "status", size: lineSize / 2 },
                        { label: "location", size: lineSize },
                        { label: "openDate", size: lineSize / 2 },
                        { label: "lastUpdate", size: lineSize / 2 },
                    ];
                } else if (isLogItem(selectedPOI)) {
                    keysToKeep = [
                        { label: "description", size: lineSize },
                        { label: "category", size: lineSize / 2 },
                        { label: "issueOwnerGroup", size: lineSize / 2 },
                        { label: "impactedFA", size: lineSize },
                        { label: "location", size: lineSize },
                        { label: "openDate", size: lineSize / 2 },
                        { label: "lastUpdate", size: lineSize / 2 },
                    ]
                } else {
                    keysToKeep = [
                        { label: "name", size: lineSize / 2 },
                        { label: "address", size: lineSize / 2 },
                        { label: "location", size: lineSize / 2 },
                        { label: "subtype", size: lineSize / 2 },
                        { label: "latitude", size: lineSize / 2 },
                        { label: "longitude", size: lineSize / 2 }
                    ];
                }

                const filtered = keysToKeep
                    .filter(keyObj => selectedPOI.hasOwnProperty(keyObj.label))
                    .map(keyObj => ({
                        ...keyObj,
                        value: ['description', 'headlineStatus'].includes(keyObj.label)
                            ? base64ToBytes(selectedPOI[keyObj.label])
                            : keyObj.label === 'location'
                                ? selectedPOI.serviceName : ['openDate', 'lastUpdate'].includes(keyObj.label) ? formatTimestamp(selectedPOI[keyObj.label], i18n.language)
                                    : selectedPOI[keyObj.label]
                    }));
                setFilteredBuilding(filtered);
            }
        } catch (error) {
            console.error('(RegisterDetailView page) Error in useEffect setting registryDetailData:', error);
            //reportError(error); // Send error report to backend
            logger.error('(RegisterDetailView page)  User: ' + user?.Username + ' Tenant: ' + tenant + ', Error in useEffect setting registryDetailData:', error)
        }
    }, [selectedPOI, i18n.language]);

    const urlToCommand = (item) => isLogItem(item) ? REACT_APP_COMMAND_LOG_ITEM_URL : REACT_APP_COMMAND_INCIDENT_URL;

    return (
        <>
            {filteredBuilding ?
                <PageContent id={filteredBuilding?.id} $backgroundColor='white'>
                    <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                        {/* <Col span={12}>
                            {selectedPOI && selectedPOI?.label === 'Item' ?
                                <Button $backgroundColor={Theme.color['white']} size='xs' $color={Theme.color['blue-4']} border={`1px solid ${Theme.color['blue-4']}`}
                                    width='100%' onClick={() => redirectToDigitalTwin(selectedPOI)}>Digital Twin</Button>
                                : null}
                        </Col> */}
                    </Row>
                    <Row gutter={[32, 32]}>
                        <Col span={24}>
                            <Row gutter={[16, 16]}>
                                <Row gutter={[16, 16]}>
                                    {filteredBuilding?.reduce((acc, item, index) => {
                                        const totalSize = acc.totalSize + item.size;
                                        if (showMore || totalSize <= maxVisibleLines * lineSize) {
                                            acc.items.push(
                                                <Col span={item.size} key={index} className='d-flex'>
                                                    <Field id={index} $backgroundColor="neutral-3" className='full-width'>
                                                        <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{t(item.label)}</Text>
                                                        <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{item.value && item.value !== '' ? item.value : '-'}</Text>
                                                    </Field>
                                                </Col>
                                            );
                                            acc.totalSize = totalSize;
                                        }
                                        return acc;
                                    }, { items: [], totalSize: 0 }).items}
                                    {filteredBuilding?.reduce((acc, item) => acc + item.size, 0) > maxVisibleLines * lineSize && (
                                        <Col span={24}>
                                            <Flex align="center" justify="center">
                                                <Flex align="center" justify="center" onClick={() => setShowMore(!showMore)} style={{ cursor: 'pointer' }}>
                                                    <Text $fontColor='blue-4' $fontSize='text_md' $weight='medium' $marginRight="s03">{showMore ? t('seeLess') : t('seeMore')}</Text>
                                                    <Icon icon={showMore ? 'ChevronUp' : 'ChevronDown'} iconsize='sm' color='blue-4' />
                                                </Flex>
                                            </Flex>
                                        </Col>
                                    )}
                                </Row>
                            </Row>
                        </Col>
                    </Row>

                    {(selectedPOI?.label === "Incident" || isLogItem(selectedPOI)) ?
                        <Row gutter={[32, 32]} style={{ marginTop: '40px' }}>
                            <Col span={24}>
                                <Button size='xxs' $backgroundColor={Theme.color['blue-4']}
                                    onClick={() => window.open(`${urlToCommand(selectedPOI)}${selectedPOI.id}`, '_blank')}
                                >
                                    {
                                        isLogItem(selectedPOI) ?
                                            t('Manage Log Item') :
                                            t('Manage Issue')
                                    }
                                </Button>
                            </Col>
                        </Row>
                        : null}

                    {selectedPOI?.label !== "Incident" && !isLogItem(selectedPOI) ?
                        <Row gutter={[32, 32]} style={{ marginTop: '40px' }}>
                            <Col span={24}>
                                <PageTitle>
                                    <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='medium' $marginRight='s03'>{t('Incidents')}</Text>
                                </PageTitle>
                            </Col>
                            {/* <Col span={24}>
                                <Button $backgroundColor='white' size='xs' $color={Theme.color['blue-4']} border={`1px solid ${Theme.color['blue-4']}`}
                                    width='100%' onClick={() => setCreateIncidentModal(true)}>{t('button.create_incident')}</Button>
                            </Col> */}
                            <Col span={24}>
                                <BasicTable tableConfiguration={tableConfiguration(t)} language={i18next.resolvedLanguage} fetchData={
                                    incidentsBuildingDrawerData ?
                                        incidentsBuildingDrawerData?.map((x, index) => {
                                            x.openDate = x.openDate.replace("T", " ");
                                            return { ...x, description: base64ToBytes(x.description), key: index };
                                        }) :
                                        []
                                } hrefLink={null} />
                            </Col>
                        </Row>
                        : null}

                    {/* <Row style={{ marginTop: '40px', display: 'flex', justifyContent: 'flex-end' }}>
                        <Col>
                            <a href={'/registry/item/' + selectedPOI?.id}>{t('seeDetail')}</a>
                        </Col>
                    </Row> */}
                </PageContent >
                : <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>
            }
        </>
    );
};

const getTabsHelper = (item) => {
    const classe = item?.class;
    switch (classe) {
        case 'Office':
            return RegisterBuildingSubTabs;
        default:
            return RegisteryGlobalSubTabs;
    };
};

const tableConfiguration = (t) => {
    return [{
        title: t('Creation Date'),
        dataIndex: "openDate"
    },
    {
        title: t('Category'),
        dataIndex: "category",
    },
    {
        title: t('Incident Description'),
        dataIndex: "description",
        width: '50%'
    },
    {
        title: t('Severity'),
        dataIndex: "priority"
    }];
};